import mutations from '@/store/modules/address/mutations';

function state() {
  return {
    companyName: '',
    street: '',
    city: '',
    state: '',
    zipCode: '',
    editingObject: null,
  };
}

export default {
  namespaced: true,
  state,
  mutations,
};
